import React from 'react'

const Block = ({ className = '', style }) => <div className={`bg-lightBG rounded ${className}`} style={style} />

const CategoryCardSkeleton = () => (
    <div className="rounded-2xl border border-[#ECEBF8] bg-white py-5 px-[22px] shadow-sm flex flex-col gap-[10px]">
        <div className="flex items-center gap-[14px]">
            <Block className="h-[56px] min-w-[56px] rounded-full opacity-50" />
            <div className="flex flex-col gap-[6px] w-full">
                <Block className="h-[17px] w-[70%] opacity-50" />
                <Block className="h-[12px] w-[90%] opacity-40" />
            </div>
        </div>
        <div className="flex items-end gap-[10px]">
            <Block className="h-[36px] w-[70px] opacity-50" />
            <Block className="h-[20px] w-[54px] rounded-full opacity-40" />
        </div>
    </div>
)

const ListRowSkeleton = ({ withAvatar = false }) => (
    <div className="flex items-center gap-[12px] py-[10px] px-[12px] rounded-[12px] bg-[#F8F8FB]">
        {withAvatar && <Block className="h-[34px] w-[34px] rounded-full opacity-50" />}
        <div className="flex flex-col gap-[6px] flex-1">
            <Block className="h-[12px] w-[60%] opacity-50" />
            <Block className="h-[10px] w-[40%] opacity-40" />
        </div>
        <Block className="h-[22px] w-[54px] rounded-full opacity-40" />
    </div>
)

const PulseCheckSkeleton = () => {
    return (
        <div className="animate-pulse">
            {/* Category row */}
            <div className="grid gap-4 mt-5" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
                {[...Array(4)].map((_, i) => (
                    <CategoryCardSkeleton key={i} />
                ))}
            </div>

            {/* Row 1: Trends chart + VsLastWeek list */}
            <div className="flex flex-row w-full gap-4 mt-5">
                <div className="flex-1 min-w-0 bg-white rounded-2xl py-[22px] px-[24px] border border-[#ECEBF8] shadow-sm">
                    <div className="flex flex-col gap-[6px] mb-3">
                        <Block className="h-[18px] w-[180px] opacity-50" />
                        <Block className="h-[12px] w-[140px] opacity-40" />
                    </div>
                    <Block className="w-full opacity-30" style={{ height: 300 }} />
                </div>
                <div className="w-[360px] bg-white rounded-2xl py-[20px] px-[22px] border border-[#ECEBF8] shadow-sm flex flex-col gap-[14px]">
                    <div className="flex flex-col gap-[6px]">
                        <Block className="h-[18px] w-[160px] opacity-50" />
                        <Block className="h-[12px] w-[120px] opacity-40" />
                    </div>
                    <div className="flex flex-col gap-[10px]">
                        {[...Array(4)].map((_, i) => (
                            <ListRowSkeleton key={i} />
                        ))}
                    </div>
                </div>
            </div>

            {/* Row 2: Heatmap grid + NeedsAttention list */}
            <div className="flex flex-row w-full gap-4 mt-5">
                <div className="flex-1 min-w-0 bg-white rounded-2xl py-[22px] px-[24px] border border-[#ECEBF8] shadow-sm">
                    <div className="flex flex-col gap-[6px] mb-4">
                        <Block className="h-[18px] w-[180px] opacity-50" />
                        <Block className="h-[12px] w-[140px] opacity-40" />
                    </div>
                    <div className="flex flex-col gap-[6px]">
                        {[...Array(5)].map((_, row) => (
                            <div key={row} className="grid gap-[6px] items-center" style={{ gridTemplateColumns: '140px repeat(7, minmax(54px, 1fr))' }}>
                                <Block className="h-[20px] w-[110px] opacity-40" />
                                {[...Array(7)].map((_, col) => (
                                    <Block key={col} className="h-[34px] rounded-[6px] opacity-30" />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="w-[360px] bg-white rounded-2xl px-[22px] py-[22px] border border-[#ECEBF8] shadow-sm flex flex-col gap-[14px]">
                    <div className="flex items-center justify-between">
                        <Block className="h-[18px] w-[160px] opacity-50" />
                        <Block className="h-[22px] w-[34px] rounded-full opacity-40" />
                    </div>
                    <div className="flex flex-col gap-[8px]">
                        {[...Array(4)].map((_, i) => (
                            <ListRowSkeleton key={i} withAvatar />
                        ))}
                    </div>
                    <Block className="h-[40px] w-full rounded-[12px] opacity-40" />
                </div>
            </div>
        </div>
    )
}

export default PulseCheckSkeleton
